import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute,Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Crest } from "src/app/classes/crest";
import { CrestService } from "src/app/services/crest.service";


@Component({
  selector: 'app-league-single',
  templateUrl: './league-single.component.html',
  styleUrls: ['./league-single.component.scss']
})
export class LeagueSingleComponent implements OnInit {
    
    busy: Subscription;
    pathList: string[][];
    id: number
    single: Crest;
    LeaguePart = "Nuova Lega"
    constructor (private ar: ActivatedRoute, private router: Router, public CrestService: CrestService) {
      this.pathList = [['leghe', 'league/list']];
    }
    loga($event) {
      this.pathList.push($event);
      console.log($event)
    }

    ngOnInit(): void {
          this.id = parseInt(this.ar.snapshot.paramMap.get('id'), 10);
          this.single = new Crest();
          
    }
}